import { EXPERIMENT_NAME_AA } from '../../common/utils/constants';
import {
	getHasSeenFirstModalAA,
	getHasSeenUrgentModalAA,
	getHasSeenFirstModalAB,
	getHasSeenUrgentModalAB,
} from '../../common/utils/local-storage';

export function getHasSeenModal(expermientName: string, isUrgent: boolean) {
	const isAA = expermientName === EXPERIMENT_NAME_AA;
	if (isUrgent) {
		return {
			hasSeenModal: isAA ? getHasSeenUrgentModalAA() : getHasSeenUrgentModalAB(),
		};
	}

	return {
		hasSeenModal: isAA ? getHasSeenFirstModalAA() : getHasSeenFirstModalAB(),
	};
}
